import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AppUserLogin = () => {
  const warehouseList = [
    "39 Hide Road Chamber-01",
    "39 Hide Road Chamber-02",
    "39 Hide Road Chamber-03",
    "39 Hide Road Chamber-04",
    "39 Hide Road Chamber-06",

    "43 Hide Road JJP-01",
    "43 Hide Road JJP-02",

    "D1 TDR",

    "Sonai Road 01",
    "Sonai Road 02",

    "(R) Shed Kantapukur",
  ];

  const navigate = useNavigate();

  // ✅ ADD warehouse_location in state
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    warehouse_location: "", // 👈 IMPORTANT
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // ✅ LOGIN API
      const res = await axios.post(
        "https://irc.zentelex.com/api/app-user-auth/login",
        formData,
      );

      const { token, user } = res.data;

      // ✅ Save token & user info
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("role", user.role);
      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem(
        "warehouse_location",
        user.warehouse_location || formData.warehouse_location,
      );

      toast.success("Login successful");

      // ✅ STEP 1: GET CURRENT STEP + CRDNO + CDDNO
      const stepRes = await axios.get(
        "https://irc.zentelex.com/api/workflow/current-step",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log(stepRes);

      const { current_step, crdNo, cddNo, isCompleted } = stepRes.data;

      // ✅ CASE 1: COMPLETED → START NEW FLOW
      if (isCompleted === true) {
        sessionStorage.removeItem("crdNo");
        sessionStorage.removeItem("cddNo");
        sessionStorage.removeItem("orderprocess");

        navigate("/dashboard");
        return;
      }

      // ✅ SAVE CRD & CDD
      if (crdNo) {
        sessionStorage.setItem("crdNo", crdNo);

        const clientRes = await axios.get(
          `https://irc.zentelex.com/api/master-client/client/by-crd/${crdNo}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        sessionStorage.setItem(
          "orderprocess",
          JSON.stringify(clientRes.data.data),
        );
      }

      if (cddNo) {
        sessionStorage.setItem("cddNo", cddNo);

        const clientRes = await axios.get(
          `https://irc.zentelex.com/api/delivery-order/by-cdd/${cddNo}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        sessionStorage.setItem(
          "deliveryorder",
          JSON.stringify(clientRes.data.data),
        );
      }

      // ================================
      // ✅ CRD ROUTES
      // ================================
      const redirectCRD = (step) => {
        switch (step) {
          case 1:
            navigate("/order-processing");
            break;
          case 2:
            navigate("/gateway-entry");
            break;
          case 3:
            navigate("/kata-slip-data");
            break;
          case 4:
            navigate("/commodity-received-document");
            break;
          default:
            navigate("/order-processing");
        }
      };

      // ================================
      // ✅ CDD ROUTES (DIFFERENT ROUTES)
      // ================================
      const redirectCDD = (step) => {
        switch (step) {
          case 1:
            navigate("/do-form");
            break;
          case 2:
            navigate("/outbound-gateway-entry");
            break;
          case 3:
            navigate("/outbound-kata-slip-data");
            break;
          case 4:
            navigate("/do-form-2");
            break;
          default:
            navigate("/do-form");
        }
      };

      // ================================
      // ✅ DECIDE WHICH FLOW TO RESUME
      // ================================
      if (cddNo) {
        redirectCDD(current_step); // ✅ CDD first
      } else if (crdNo) {
        redirectCRD(current_step); // ✅ CRD second
      } else {
        navigate("/dashboard"); // ✅ new flow
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="container d-flex justify-content-center align-items-center min-vh-100">
        <div
          className="card shadow p-4"
          style={{ width: "400px", backgroundColor: "#3075A6" }}
        >
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="btn btn-link p-0 mb-3"
            style={{
              color: "white",
              textDecoration: "none",
              fontSize: "14px",
            }}
          >
            ← Back
          </button>

          <h4 className="text-center mb-4" style={{ color: "white" }}>
            QC / Operations / Accounts Login
          </h4>

          <form onSubmit={handleSubmit}>
            {/* Email */}
            <div className="mb-3">
              <label className="form-label" style={{ color: "white" }}>
                Email
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Warehouse Location */}
            <div className="mb-4">
              <label className="form-label text-white fw-semibold">
                Warehouse Location
              </label>
              <select
                name="warehouse_location"
                value={formData.warehouse_location}
                onChange={handleChange}
                className="form-select"
              >
                <option value="">Select warehouse</option>
                {warehouseList.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            {/* Password */}
            <div className="mb-3">
              <label className="form-label" style={{ color: "white" }}>
                Password
              </label>
              <input
                type="password"
                className="form-control"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <button
              type="submit"
              className="btn w-100"
              style={{
                backgroundColor: "#EC662C",
                color: "white",
              }}
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default AppUserLogin;
